<display-form [displayObject]="displayObject"></display-form>